var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuessDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.947,
    height: 18,
    viewBox: "0 0 18.947 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26907",
    "data-name": "Trac\\xE9 26907",
    d: "M20.105,8.789H17.263V7.842A2.844,2.844,0,0,0,14.421,5H12.526A2.844,2.844,0,0,0,9.684,7.842v.947H6.842A2.844,2.844,0,0,0,4,11.632v8.526A2.844,2.844,0,0,0,6.842,23H20.105a2.844,2.844,0,0,0,2.842-2.842V11.632A2.844,2.844,0,0,0,20.105,8.789Zm-8.526-.947a.95.95,0,0,1,.947-.947h1.895a.95.95,0,0,1,.947.947v.947H11.579Zm9.474,12.316a.95.95,0,0,1-.947.947H6.842a.95.95,0,0,1-.947-.947V14.947a20.585,20.585,0,0,0,2.842.891V16.4a.947.947,0,0,0,1.895,0v-.2a21.929,21.929,0,0,0,2.842.2,21.929,21.929,0,0,0,2.842-.2v.2a.947.947,0,0,0,1.895,0v-.559a20.585,20.585,0,0,0,2.842-.891Zm0-7.285a19.42,19.42,0,0,1-2.842.947v-.294a.947.947,0,1,0-1.895,0v.7a19.054,19.054,0,0,1-5.684,0v-.7a.947.947,0,1,0-1.895,0v.313a19.419,19.419,0,0,1-2.842-.947v-1.26a.95.95,0,0,1,.947-.947H20.105a.95.95,0,0,1,.947.947Z",
    transform: "translate(-4 -5)",
    fill: "#6f7070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuessDocs);
export default __webpack_public_path__ + "static/media/quess_docs.55f897826480cf3ba8a7e2f801f79044.svg";
export { ForwardRef as ReactComponent };